import { createFileRoute } from "@tanstack/react-router";

import AccountDeletedPage from "./-components/AccountDeletedPage";

export const Route = createFileRoute("/_app/accountdeleted")({
  component: AccountDeletedPage,
});
